import { createSlice } from '@reduxjs/toolkit'
import axios from '../../api/index'
import { failed, success, info } from './snackSlice'
import { startLoading, stopLoading } from './loadingSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    unseen: undefined,
    totalHits: 0,
    list: [],
    ageCategories: [],
  },
  reducers: {
    notificationFetched: (state, { payload }) => ({ ...state, ...payload }),
    numberOfUnseenFetched: (state, { payload }) => ({ ...state, unseen: payload }),
    ageCategoriesFetch: (state, { payload }) => {
      state.ageCategories = payload
    },
  },
})

export default notificationSlice.reducer

export const {
  notificationFetched,
  numberOfUnseenFetched,
  userNotificationFetched,
  ageCategoriesFetch,
} = notificationSlice.actions

export const getAllNotifications = ({
  first = muiDefaultOptions.rowsPerPage,
  after = 0,
}) => (dispatch) => {
  dispatch(startLoading())
  axios.get(`Notification/All?first=${first}&after=${after}`)
    .then((res) => {
      dispatch(stopLoading())
      dispatch(notificationFetched({
        list: res?.data.data,
        totalHits: res?.data?.totalHits,
      }))
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در دریافت اعلانات'))
    })
}

export const getNotifications = ({ first, after }) => (dispatch) => {
  dispatch(startLoading())
  axios.get(`notification?first=${first}&after=${after}`)
    .then((res) => {
      dispatch(stopLoading())

      if (res?.data.data.length === 0) dispatch(info('اعلان جدیدی موجود نمی‌باشد'))
      dispatch(
        notificationFetched({
          list: res?.data.data,
          totalHits: res?.data?.totalHits,
        }),
      )
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در دریافت اعلانات'))
    })
}

export const addNotification = (data) => (dispatch) => {
  dispatch(startLoading())
  axios.post('notification', data)
    .then(() => {
      dispatch(stopLoading())
      dispatch(success('اعلان جدید اضافه گردید'))
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در افزودن اعلان جدید'))
    })
}

export const deleteNotification = (dataList) => (dispatch) => {
  dispatch(startLoading())
  axios.delete(`Notification/${dataList[0]}`, dataList)
    .then(() => {
      dispatch(stopLoading())
      dispatch(success('اعلان حذف گردید'))
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
      // dispatch(failed('مشکل در حذف اعلان جدید'))
    })
}

export const getUnseenNumber = () => (dispatch) => {
  dispatch(startLoading())
  axios.get('notification/unseen/count')
    .then((data) => {
      dispatch(stopLoading())
      dispatch(numberOfUnseenFetched(data.data.data))
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const seenNotifications = (notificationIdList) => (dispatch) => {
  dispatch(startLoading())
  axios.post('Notification/seen', notificationIdList)
    .then(() => {
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(stopLoading())
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const getAllAgeCategories = () => (dispatch) => {
  dispatch(startLoading())
  axios.get('/common/agecategories')
    .then((data) => {
      dispatch(stopLoading())
      dispatch(ageCategoriesFetch(data?.data?.data))
    })
    .catch((e) => {
      dispatch(stopLoading())
      console.error(e)
    })
}

export const selectorUnseenNotifications = (state) => state.notifications.unseen
export const selectorAgeCategories = (state) => state.notifications.ageCategories
